import { useState, useEffect } from 'react';
import { Disciple3000 } from './Disciple3000';
import { MinistryTeam1000 } from './MinistryTeam1000';
import { Vision2028Badge } from './Vision2028Badge';
import { CollapseIcon } from './CollapseIcon';
import { Vision2028Progress } from './Vision2028Progress';
import styles from './Vision2028.module.css';

/**
 * 비전 2028 패널
 * : 삼천제자, 일천사역팀 패널을 열림/닫힘 상태를 관리한다.
 */
export const Vision2028 = () => {
  // localStorage에서 패널 상태 불러오기 (기본값: false - 열려있음)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('vision2028_panel_collapsed');
    if (saved === null) return false; // 기본값: 열려있음
    return saved === 'true'; // 'true' 문자열이면 닫힘, 'false' 문자열이면 열림
  });

  /**
   * 패널 상태 변경 시 localStorage에 저장
   */
  useEffect(() => {
    localStorage.setItem('vision2028_panel_collapsed', String(isCollapsed)); // 패널 상태 변경 시 localStorage에 저장
  }, [isCollapsed]);

  return (
    <div className={`row ${styles.container}`}>
      <div className={`panel ${styles.panel}`}>
        <div className={`panel-heading ${styles.panelHeading}`} onClick={() => setIsCollapsed(!isCollapsed)}>
          <div className={styles.titleWrapper}>
            <Vision2028Badge />
            <h3 className={styles.title}>삼천제자, 일천사역팀</h3>
          </div>
          <div className={styles.headerRight}>
            <Vision2028Progress />
            <CollapseIcon isCollapsed={isCollapsed} /> {/* 패널 열림/닫힘 아이콘 */}
          </div>
        </div>

        {!isCollapsed && (
          <div className={`panel-body ${styles.panelBody}`}>
            <div className="row">
              <Disciple3000 />
              <MinistryTeam1000 />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
